import { Button, Grid } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const NavigateButtons = ({
  onBack,
  onNext,
  showNext = true,
  showBack = true,
  nextLabel = '',
  backLabel = '',
  nextProps = {},
  backProps = {}
}) => {
  const { t } = useTranslation()
  return (
    <Grid>
      <RowStack width='unset' spacing={8} data-testid='navigation-bar'>
        {showBack && (
          <Button
            color='muted'
            onClick={onBack}
            startIcon={<ArrowBackIcon />}
            {...backProps}>
            {backLabel || t('common.back')}
          </Button>
        )}
        {showNext && (
          <Button
            onClick={onNext}
            endIcon={<ArrowForwardIcon />}
            {...nextProps}>
            {nextLabel || t('common.continue')}
          </Button>
        )}
      </RowStack>
    </Grid>
  )
}

export default NavigateButtons
